
import { createContext } from 'react';
import { DefaultApi } from '../client-sdk/api';

export const HimmaContext = createContext<DefaultApi | undefined>(undefined);
 